import SolutionChallengesI18n from "@/components/landing/shared/SolutionChallengesI18n";
import { Clock, Users, TrendingDown, MessageSquareOff } from "lucide-react";
const MarketingChallengesSection = () => <SolutionChallengesI18n translationPrefix="marketingSolution" icons={[Clock, Users, TrendingDown, MessageSquareOff]} />;
export default MarketingChallengesSection;
